import useStateRef from "react-usestateref";
import { useEffect } from "react";
import { CreatorEdgesStore } from "./CreatorEdgesStore";
import { getIt } from "@uikit/getIt";

const creatorEdgesStore = getIt(CreatorEdgesStore);

export function useCreatorEdgesState() {
  const [edges, setEdges] = useStateRef(creatorEdgesStore.state.edges);

  useEffect(() => {
    function subscription(val: typeof creatorEdgesStore.state) {
      setEdges(val.edges);
    }

    const sub = creatorEdgesStore.on(subscription, true);
    return () => {
      sub.off();
    };
  }, []);

  return { edges };
}
